import { render, staticRenderFns } from "./SignupStepFrame.vue?vue&type=template&id=af8fc286&scoped=true&"
import script from "./SignupStepFrame.vue?vue&type=script&lang=js&"
export * from "./SignupStepFrame.vue?vue&type=script&lang=js&"
import style0 from "./SignupStepFrame.vue?vue&type=style&index=0&id=af8fc286&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8fc286",
  null
  
)

export default component.exports